import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ImageUrl, ScreenshotDataUrl, ScreenshotId} from '@webmate-web-core/shared/types/ids';
import {StateInfoItem} from '@webmate-web-core/shared/components/state/stateinfoitemrendererfactory';
import {ImageOverlay} from '@webmate-web-core/shared/api/rest/image.restapi';
import {SmallId} from '@webmate-web-core/shared/types/base-types';
import {CanvasBasedImageComponent, OverlayHitEvent} from '@webmate-web-core/shared/components/screenshot/canvas-based-image.component';
import {
    ScreenshotViewerComponent,
    ScreenshotViewerToolConfig
} from '@webmate-web-core/shared/tools/screenshotviewer/screenshotviewer.component';
import {ModalToolContainerService} from '@webmate-web-core/shared/tools/modaltoolcontainer/modaltoolcontainer.service';
import {ImageService} from '@webmate-web-core/shared/services/image.service';

@Component({
  selector: 'wm-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.less'],
})
export class ImageComponent implements OnChanges {

    @ViewChild('canvasImage') canvasImage: CanvasBasedImageComponent;

    @Input()
    downloadable: boolean = false;

    @Input()
    displayMode?: 'with_draw_canvas' | 'without_draw_canvas' | 'auto' = 'auto';

    @Input()
    imageId?: ScreenshotId;

    @Input()
    imageUrl?: ScreenshotDataUrl | ImageUrl;

    @Input()
    small?: boolean = false;

    @Input()
    showOverlays?: boolean = true;

    @Input()
    infoItems: StateInfoItem[] = [];

    @Input()
    additionalOverlays?: ImageOverlay[];

    @Input()
    overlayHandlesFor?: SmallId[];

    @Input()
    scale?: boolean = false;

    @Input()
    fillContainer: boolean = false;

    @Input()
    allowToOpenScreenshotToolInPopup: boolean = false;

    @Input()
    editable: boolean = false;

    hasOverlaysToShow: boolean = false;

    @Output()
    error = new EventEmitter<any>();

    @Output()
    overlayHit = new EventEmitter<OverlayHitEvent>();

    constructor(private toolService: ModalToolContainerService, private readonly imageService: ImageService) {}

    openScreenshotTool() {
        if (this.allowToOpenScreenshotToolInPopup) {
            this.toolService.openTool(ScreenshotViewerComponent, new ScreenshotViewerToolConfig(this.imageId, this.imageUrl, undefined, false, this.allowToOpenScreenshotToolInPopup, undefined, () => {
                this.checkForOverlays(this.imageId);
            }));
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes.imageId?.currentValue && changes.imageId.currentValue !== changes.imageId.previousValue) {
            this.checkForOverlays(changes.imageId.currentValue);
        }
    }

    private checkForOverlays(imageId: ScreenshotId): void {
        this.imageService.getImageMetadata(imageId).subscribe(meta => {
            this.hasOverlaysToShow = !!meta.overlays && meta.overlays.length > 0;
            if (this.hasOverlaysToShow && !!this.canvasImage) {
                this.canvasImage.refreshOverlays(meta);
            }
        });
    }
}
